import { NavigateOptions, To, useNavigate as _useNavigate, useLocation } from "react-router-dom";

/**
 * 현재 경로의 파트너 코드(`/partner/{code}`)를 대상 경로(to)에 자동 삽입하는 navigate 래퍼.
 * ※ 언어(`?lang=`)는 URL 에 부착하지 않는다. 언어 지속은 i18n 의 localStorage 캐시가 담당하므로
 *    페이지 이동 시 URL 을 깔끔하게 유지한다.
 */
export const usePartnerNavigate = () => {
  const _navigate = _useNavigate();
  const location = useLocation();

  function navigate(to: To | number, options?: NavigateOptions) {
    if (typeof to === "string") {
      const pathname = location.pathname;
      const pathnameArray = pathname.split("/");

      //배열로 만들고 배열안에 "partner"가 있는지 확인
      const partnerIndex = pathnameArray.findIndex((item) => item === "partner");
      //partner가 있으면 그 뒤에 있는 값을 가져오고 없으면 빈 문자열 반환
      const partnerCode = partnerIndex !== -1 ? pathnameArray[partnerIndex + 1] : "";

      // to = http://localhost:3100/front/court/main
      // newto = http://localhost:3100/front/court/partner/${partnerCode}/main

      if (partnerCode) {
        // newto 는 to 를 배열로 만들고 "court" 뒤에 partner/${partnerCode} 를 삽입해줘
        const newToArr = to.split("/");
        newToArr.splice(2, 0, `partner/${partnerCode}`);
        const newTo = newToArr.join("/");

        return _navigate(newTo, options);
      }

      return _navigate(to, options);
    }

    if (typeof to === "number") {
      return _navigate(to);
    }
  }

  return navigate;
};
